import styled from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { FontWeight } from 'commons';

const WIDTH = '6cm';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 96px;
  padding: 24px 18px;
  zoom: 150%;

  ${TextStyle} {
    line-height: 24px;

    strong {
      font-weight: ${FontWeight.bold};
    }
  }
`;

export const Content = styled.div`
  width: ${WIDTH};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Consignments = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 2px;

  ${HeadingStyle} {
    margin-bottom: 16px;
  }
`;

export const SignatureImageContainer = styled.div`
  width: ${WIDTH};
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
  }
`;

export const SignatureContainer = styled.div`
  width: ${WIDTH};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const Signature = styled.div`
  width: ${WIDTH};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 8px;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 1px;
    background-color: #000;

    @media print {
      background-color: #000;
      -webkit-print-color-adjust: exact;
    }
  }
`;
